import comp from "./Message";
export default comp;
